<template>
  <div class="login-wrap  login-wrap-background">
    <!-- <div class="headerbg"><div class="logo" /></div> -->
    <!-- <div class="video-container">
      <div :style="fixStyle" class="filter" />
      <video :style="fixStyle" autoplay loop class="fillWidth" @canplay="canplay">
        <source :src="PATH_TO_MP4" type="video/mp4">
        浏览器不支持 video 标签，建议升级浏览器。
        <source src="PATH_TO_WEBM" type="video/webm">
        浏览器不支持 video 标签，建议升级浏览器。
      </video>
      <div v-if="!vedioCanPlay" class="poster hidden">
        <img :style="fixStyle" :src="PATH_TO_JPEG" alt="">
      </div>
    </div> -->
    <!-- <div class="login-pic" /> -->
    <div class="login-content">
      <div class="pic-title"><img src="../../assets/images/SCT1.svg"></div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="login-form" auto-complete="on" label-position="left">
        <!-- <div class="title-container">
          <h3 class="title">
            {{ $t('login.title') }}
          </h3>
          <lang-select class="set-language" />
        </div> -->
        <el-form-item prop="userNo">
          <span class="svg-container">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            v-model="ruleForm.userNo"
            :disabled="disabledInput"
            size="medium"
            :placeholder="$t('login.username')"
            name="username"
            type="text"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            v-model="ruleForm.pwd"
            size="medium"
            class="login-form-input"
            :type="passwordType"
            :placeholder="$t('login.password')"
            name="password"
            auto-complete="on"
            @keyup.enter.native="submitForm('ruleForm')"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <el-form-item prop="verify">
          <span class="svg-container">
            <svg-icon icon-class="mobile" style="font-size:18px;" />
          </span>
          <el-input
            v-model="ruleForm.yzmCode"
            :disabled="disabledInput"
            size="medium"
            placeholder="输入短信验证码"
            name="yzmCode"
            type="text"
            auto-complete="on"
          />
          <span class="send-code">
            <span v-if="codeShow"><el-button size="small" type="info" @click.native.prevent="verificationCode('ruleForm')">获取验证码</el-button></span>
            <span v-if="!codeShow"><el-button size="small" disabled type="info">{{count}}秒后重试</el-button></span>
          </span>
        </el-form-item>
        <el-button :loading="loading" size="medium" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="submitForm('ruleForm')">
          {{ $t('login.logIn') }}
        </el-button>
      </el-form>
<!--      <div class="red text-center">为获得更好的系统体验，请使用Google Chrome浏览器！</div>-->
    </div>
    <div class="recordInformation">
      <img src="../../assets/images/i_record.png" />
      <a href="https://beian.miit.gov.cn/#/Integrated/index"
      >沪ICP备16025938号-4</a
      >
    </div>
  </div>
</template>

<script>
// import LangSelect from '@/Subassembly/LangSelect'
import mp4Path from "../../../static/1080p.mp4";
import jpegPath from "../../assets/images/ok-cover.jpg";
import axios from "axios";

export default {
  name: "Login",
  components: {
    // LangSelect
  },
  data: function () {
    return {
      disabledInput: false,
      submitData: {
        userNo: "",
        pwd: "",
        yzmCode: "",
      },
      vedioCanPlay: false,
      fixStyle: "",
      PATH_TO_MP4: "",
      PATH_TO_JPEG: "",
      loading: false,
      passwordType: "password",
      ruleForm: {
        userNo: "",
        pwd: "",
        userLanguage: "zh-CN",
        userNoDisabled: false,
        pwdDisabled: false,
        adUserName: "",
        adPassword: "",
        yzmCode: "",
      },
      rules: {
        userNo: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      languageList: [
        { langKey: 1, langName: "中文", langValue: "zh-CN" },
        { langKey: 2, langName: "English", langValue: "en" },
      ],
      fmMenus: [],
      isAdLogin: false,
      codeShow: true,  //判断显示隐藏
      count: '',     //显示时的文字内容
      timer: null,
    };
  },
  computed: {
    addRouters() {
      return this.$store.state.login.addRouters;
    },
  },
  watch: {
    isAdLogin(value) {
      if (value) {
        if (window.location.href.indexOf(process.env.AD_DOMAIN) == -1)
          window.location.href = process.env.AD_DOMAIN + "/login";
      } else {
        if (window.location.href.indexOf(process.env.DOMAIN) == -1)
          window.location.href = process.env.DOMAIN + "/login";
      }
    },
  },
  created() {
    this.$store.dispatch("tagsView/toggleSideBar");
    this.canplay();
    this.PATH_TO_JPEG = jpegPath;
    this.PATH_TO_MP4 = mp4Path;
  },
  mounted: function () {
    window.onresize = () => {
      const windowWidth = document.body.clientWidth;
      const windowHeight = document.body.clientHeight;
      const windowAspectRatio = windowHeight / windowWidth;
      let videoWidth;
      let videoHeight;
      if (windowAspectRatio < 0.5625) {
        videoWidth = windowWidth;
        videoHeight = videoWidth * 0.5625;
        this.fixStyle = {
          height: windowWidth * 0.5625 + "px",
          width: windowWidth + "px",
          "margin-bottom": (windowHeight - videoHeight) / 2 + "px",
          "margin-left": "initial",
        };
      } else {
        videoHeight = windowHeight;
        videoWidth = videoHeight / 0.5625;
        this.fixStyle = {
          height: windowHeight + "px",
          width: windowHeight / 0.5625 + "px",
          "margin-left": (windowWidth - videoWidth) / 2 + "px",
          "margin-bottom": "initial",
        };
      }
    };
    window.onresize();

    this.isAdLogin = false;

    if (this.isAdLogin) {
      this.adLogin();
    }

    this.ruleForm.userNoDisabled = this.isAdLogin;

    // this.domainData("http://10.23.61.53:8055/auth", (res) => {
    //   if (res && res.username) {
    //     this.ruleForm.userNo = res.username.split('\\')[1];
    //     this.ruleForm.adUserName = res.username;
    //     this.ruleForm.adPassword = res.password;
    //     this.ruleForm.pwdDisabled = false;
    //     this.isAdLogin = true;
    //   } else {
    //     this.ruleForm.userNoDisabled = false;
    //     this.ruleForm.pwdDisabled = false;
    //     this.isAdLogin = false;
    //   }
    //   this.$hideLoading();
    // });
  },
  methods: {
    canplay() {
      this.vedioCanPlay = true;
      console.log(this.vedioCanPlay);
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    inputToDisabled() {
      if (this.ruleForm.radioDomain === '1') {
        this.disabledInput = false
      } else {
        this.disabledInput = true
      }
    },
    selectLanguage(lang) {
      this.$i18n.locale = lang;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.submitData.userNo = this.isAdLogin
            ? this.ruleForm.adUserName
            : this.ruleForm.userNo;
          this.submitData.pwd = this.ruleForm.pwd; // md5.hex_md5(this.ruleForm.pwd).toUpperCase();
          this.submitData.userLanguage = this.ruleForm.userLanguage;
          this.submitData.platForm = "Web";
          this.submitData.userCategory = this.isAdLogin ? "office" : "other";
          this.submitData.yzmCode = this.ruleForm.yzmCode;

          this.$store
            .dispatch("login/fmUserLoginRequest", this.submitData)
            .then(() => {
              localStorage.setItem("ms_username", this.ruleForm.userNo);
              this.$router.addRoutes(this.addRouters);
              this.$router.push("/");
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    verificationCode(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData.userNo = this.isAdLogin
            ? this.ruleForm.adUserName
            : this.ruleForm.userNo;
          this.submitData.pwd = this.ruleForm.pwd; // md5.hex_md5(this.ruleForm.pwd).toUpperCase();
          this.submitData.userLanguage = this.ruleForm.userLanguage;
          this.submitData.platForm = "Web";

          this.$store
            .dispatch("login/generateVerificationCode", this.submitData)
            .then(() => {
              var countDownFlag = this.$store.state.login.yzmRes
              if (countDownFlag.code === 200) {
                this.countDowm()
              }
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    countDowm(){
      //点击获取验证码
      const TIME_COUNT = 30;  //倒计时30秒
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    adLogin() {
      this.$showLoading();

      $.ajax({
        type: "GET",
        url: "http://10.23.61.53:8058/auth",
        timeout: 5000,
        xhrFields: {
          withCredentials: true,
        },
        success: (res) => {
          if (res && res.username) {
            this.ruleForm.adUserName = this.ruleForm.userNo = res.username.split(
              "\\"
            )[1];
            this.ruleForm.adPassword = res.password;
            // this.ruleForm.pwdDisabled = false;
            // this.isAdLogin = true;
          } else {
            // this.ruleForm.userNoDisabled = false;
            // this.ruleForm.pwdDisabled = false;
            // this.isAdLogin = false;
          }
          this.$hideLoading();
        },
        error: (XMLHttpRequest, textStatus, errorThrown) => {
          // this.ruleForm.userNoDisabled = false;
          // this.ruleForm.pwdDisabled = false;
          // this.isAdLogin = false;
          this.$hideLoading();
        },
      });

      // axios
      //   .create({
      //     baseURL: "http://10.23.61.53:8055",
      //     timeout: 5000, // 请求超时时间
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     withCredentials: false,
      //   })
      //   .get("/auth")
      //   .then((res) => {

      //   })
      //   .catch((err) => {
      //     console.log(err);

      //   });
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
  .login-wrap{
    font-family: "Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",Arial, Helvetica, sans-serif;
    font-size: 13px;
    .el-form-item__content{
      position: relative!important;
      .el-input__inner {
        padding-left: 40px!important;
      }
    }
    .el-form-item__label,.el-radio__label{
      color:#808080;
      font-size:14px;
      font-weight: 550;
    }
    input[type="text"]:read-only,input[type="text"]:disabled
    {
      background-color: #dedede;
      color:#999;
    }
  }

</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  $defaultColor:#353535;
  $pinkColor:#FFF0E3;
  $dark_gray:#999;
  $light_gray:#F4EEEA;
  .video-container {
    position: relative;
    height: 100vh;
    overflow: hidden;
  }

  .video-container .poster img,
  .video-container video {
    z-index: 0;
    position: absolute;
  }

  .video-container .filter {
    z-index: 1;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
  }
  .login-wrap{
    width:100%;
    height:100%;
    overflow: hidden;
    // background:$light_gray;
    background:url("../../assets/images/pclogin.jpg")  no-repeat center;
    background-size: 100%;
    .headerbg{
      background-color:$defaultColor;
      width: 100%;
      position: absolute;
      top:0;
      left:0;
      height: 85px;
      z-index: 99;
    }
    .login-content{
      position: absolute;
      width: 460px;
      right:calc(50% - 230px);
      top:calc(50% - 195px);
      background:rgba(230,230,230,0.78);
      box-shadow: 5px 5px 5px rgba(0,0,0,0.3);
      padding: 10px;
      border-radius: 5px;
      z-index: 99;
      .pic-title{
        width: 80%;
        margin: auto auto 0;
        img{
          width: 100%;
        }
      }
    }
    .domain{
      margin-bottom: 20px;
    }
    .login-form {
      width: 98%;
      height:250px;
      padding: 15px 35px 0;
      margin: 0 auto;
      /*overflow: hidden;*/
      // background: rgba(255,255,255,0.8);
      // box-shadow: 0 0 5px rgba(255,255,255,0.8);
      border-radius: 10px;
      .el-form-item{
        margin-bottom: 18px;
      }
    }
    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;
      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }
    .svg-container {
      padding: 0;
      color: $dark_gray;
      width: 30px;
      position: absolute;
      top: 2px;
      left:10px;
      z-index: 1000;
      display: block;
    }
    .title-container {
      position: relative;
      .title {
        font-size: 22px;
        margin: 0px 0 18px;
        font-weight: bold;
        color: $defaultColor;
      }
      .set-language {
        position: absolute;
        top: 3px;
        font-size:18px;
        right: 0px;
        cursor: pointer;
      }
    }
    .show-pwd {
      position: absolute;
      right: 10px;
      top: 2px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }
    .send-code {
      position: absolute;
      right: 2px;
      top: -1px;
      font-size: 16px;
      cursor: pointer;
      user-select: none;
    }
    .thirdparty-button {
      position: absolute;
      right: 0;
      bottom: 6px;
    }
  }

  .recordInformation {
    position: absolute;
    bottom: 10px;
    right: 100px;
  }
  .recordInformation img {
    width: 15px;
    margin-right: 5px;
  }
  .recordInformation a {
    font-size: 14px;
  }

  .recordInformation a:link {
    color: rgb(57, 61, 88);
  }

  .recordInformation a:visited {
    color: rgb(57, 61, 88);
  }
</style>



// WEBPACK FOOTER //
// src/view/Login/Login.vue